import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-10 relative w-full max-w-2xl mx-auto">
          <div className="w-full h-56 md:h-72 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20dark%20mode%20spreadsheet%20interface%20with%20colorful%20data%20visualization%20charts%2C%20clean%20product%20catalog%20layout%2C%20warm%20accent%20colors%2C%20professional%20dashboard%20design%2C%20minimal%20UI%2C%20tech%20editorial%20photography&width=1400&height=600&seq=cta-table-v2&orientation=landscape"
              alt="Itaobuy spreadsheet product interface"
              title="ItaobuySpreadsheet Product Data Interface"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.2] mb-4">
          Stop sourcing alone.<br />
          <span className="font-normal text-foreground-500 italic">Start scaling smarter</span><br />
          <span className="font-bold">with itaobuy sheet.</span>
        </h2>

        <p className="text-base text-foreground-600 max-w-xl mx-auto mb-8 leading-relaxed">
          Stop wasting time on manual sourcing. Access structured spreadsheets now and streamline your product sourcing process.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Get Started Now
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold border-2 border-primary-500 text-primary-500 rounded-full hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Live Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}